module.exports = __webpack_public_path__ + "img/pocket-6_jp.5173e11.jpg";